/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LeadAssignment } from './LeadAssignment';
import {
    LeadAssignmentFromJSON,
    LeadAssignmentFromJSONTyped,
    LeadAssignmentToJSON,
} from './LeadAssignment';

/**
 * 
 * @export
 * @interface SetLeadAssignments200ResponseData
 */
export interface SetLeadAssignments200ResponseData {
    /**
     * 
     * @type {Array<LeadAssignment>}
     * @memberof SetLeadAssignments200ResponseData
     */
    assignments: Array<LeadAssignment>;
}

/**
 * Check if a given object implements the SetLeadAssignments200ResponseData interface.
 */
export function instanceOfSetLeadAssignments200ResponseData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "assignments" in value;

    return isInstance;
}

export function SetLeadAssignments200ResponseDataFromJSON(json: any): SetLeadAssignments200ResponseData {
    return SetLeadAssignments200ResponseDataFromJSONTyped(json, false);
}

export function SetLeadAssignments200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetLeadAssignments200ResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'assignments': ((json['assignments'] as Array<any>).map(LeadAssignmentFromJSON)),
    };
}

export function SetLeadAssignments200ResponseDataToJSON(value?: SetLeadAssignments200ResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'assignments': ((value.assignments as Array<any>).map(LeadAssignmentToJSON)),
    };
}

